var map = {
	"./Cryptos.svg": "d970",
	"./Rectangle.svg": "37ce",
	"./arrow-left.svg": "b078",
	"./black-search.svg": "2a44",
	"./blackeye.svg": "7022",
	"./businessman.svg": "1ef0",
	"./calender.svg": "d8f7",
	"./carousel-arrow-right.svg": "f06c",
	"./carousel-arrow.svg": "6bba",
	"./caution.svg": "b083",
	"./chat.svg": "c857",
	"./commission.svg": "e283",
	"./cross.svg": "d423",
	"./email.svg": "fab0",
	"./eye.svg": "a264",
	"./ez-use.svg": "7789",
	"./fingerprint.svg": "4ac0",
	"./gear.svg": "851a",
	"./google-icon.svg": "c822",
	"./hours-support.svg": "4093",
	"./instagram.svg": "93f3",
	"./landingbg.svg": "ab6d",
	"./location.svg": "f7f5",
	"./log.svg": "97a5",
	"./phone.svg": "9a81",
	"./save-money.svg": "791c",
	"./search.svg": "5b28",
	"./square.svg": "2229",
	"./three-coin.svg": "1616",
	"./trade-safety.svg": "13ab",
	"./trash.svg": "a6a7",
	"./user.svg": "4f5c",
	"./wallet-charge.svg": "ef38"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "959c";